module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-menu horizontal-menu",
    style: ({
      'background-color': _vm.customization.mainColor,
      color: _vm.customization.iconColor,
    })
  }, [_c('a', {
    staticClass: "menu-item",
    style: ({
      'border-color': _vm.borderColor
    }),
    attrs: {
      "href": "recommendfriend"
    }
  }, [_c('span', {
    staticClass: "menu-icon dbc-icon dbc-icon-users-three"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Refer\n      "), _c('span', {
    staticClass: "badge",
    style: ({
      color: _vm.customization.mainColor
    }),
    attrs: {
      "v-if": _vm.referralsCount
    }
  }, [_vm._v(_vm._s(_vm.referralsCount))])]), _vm._v(" "), _c('span', {
    staticClass: "menu-arrow dbc-icon dbc-icon-angle-arrow-down"
  })]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    style: ({
      'border-color': _vm.borderColor
    }),
    attrs: {
      "href": "garage"
    }
  }, [_c('span', {
    staticClass: "menu-icon dbc-icon dbc-icon-solid_car"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("My Garage\n      "), (_vm.purchasedVehiclesCount && _vm.homePageMenuType.bottomList) ? _c('span', {
    staticClass: "badge",
    style: ({
      color: _vm.customization.mainColor
    })
  }, [_vm._v(_vm._s(_vm.purchasedVehiclesCount))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "menu-arrow dbc-icon dbc-icon-angle-arrow-down"
  })]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    style: ({
      'border-color': _vm.borderColor
    }),
    attrs: {
      "href": "contact"
    }
  }, [_c('span', {
    staticClass: "menu-icon dbc-icon dbc-icon-card-account-phone"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('span', {
    staticClass: "menu-arrow dbc-icon dbc-icon-angle-arrow-down"
  })]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    style: ({
      'border-color': _vm.borderColor
    }),
    attrs: {
      "href": "inventory"
    }
  }, [_c('span', {
    staticClass: "menu-icon dbc-icon dbc-icon-map_car-dealer"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Shop")]), _vm._v(" "), _c('span', {
    staticClass: "menu-arrow dbc-icon dbc-icon-angle-arrow-down"
  })]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    style: ({
      'border-color': _vm.borderColor
    }),
    attrs: {
      "href": "about"
    }
  }, [_c('span', {
    staticClass: "menu-icon dbc-icon dbc-icon-businessman"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("About")]), _vm._v(" "), _c('span', {
    staticClass: "menu-arrow dbc-icon dbc-icon-angle-arrow-down"
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-cab3f556", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cab3f556"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/home-page-components/bottom-panel-menu.component.vue
// module id = 866
// module chunks = 0